import { createSlice } from '@reduxjs/toolkit';

export const TABLE_VIEW = 'table';
export const CARD_VIEW = 'card';

const initialState = {
  formData: {
    activity: [],
    city: [],
    department: [],
    juridique: [],
    financials: [],
  },
  filters: null,
  finalQuery: null,
  searchQuery: null,
  searchText: '',
  searchValue: '',
  page: 1,
  view: TABLE_VIEW,
};

export type CompanyFormState = Readonly<typeof initialState>;

export const companyFormSlice = createSlice({
  name: 'companyForm',
  initialState: initialState as CompanyFormState,
  reducers: {
    setFormData(state, action) {
      state.formData = action.payload;
    },
    setFilters(state, action) {
      state.filters = action.payload;
    },
    setFinalQuery(state, action) {
      state.finalQuery = action.payload;
    },
    setSearchQuery(state, action) {
      state.searchQuery = action.payload;
    },
    setSearchText(state, action) {
      state.searchText = action.payload;
    },
    setSearchValue(state, action) {
      state.searchValue = action.payload;
    },
    setPage(state, action) {
      state.page = action.payload;
    },
    setView(state, action) {
      state.view = action.payload;
    },
  },
});

export const {
  setFormData,
  setFilters,
  setFinalQuery,
  setSearchQuery,
  setSearchText,
  setSearchValue,
  setPage,
  setView,
} = companyFormSlice.actions;

export default companyFormSlice.reducer;
